<div class="mat-dialog-cont mt-2" >
  <div class="header">
    <strong>{{'BUTTONS.MULTI_ASSIGNMENT' | translate}}</strong>
    <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="records-section">
    <!-- Filter Section -->
    <div class="p-3 border-bottom">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">{{'FILTERS.SERIAL_NUMBER' | translate}}</label>
          <ng-select
            [(ngModel)]="serialNumberFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'FILTERS.SERIAL_NUMBER_PLACEHOLDER' | translate"
            [clearable]="true"
            [searchable]="true"
            bindLabel="serialNumber"
            bindValue="serialNumber"
            >
            @for (device of devices; track device) {
              <ng-option [value]="device.serialNumber">
                {{device.serialNumber}}
              </ng-option>
            }
          </ng-select>
        </div>
        <div class="col-md-3 date-input">
          <label class="form-label">{{'FILTERS.START_DATE' | translate}}</label>
          <input
            type="date" class="form-control input-field"
            [(ngModel)]="startDateFilter"
            (ngModelChange)="onFilterChange()">
          </div>
          <div class="col-md-3 date-input">
            <label class="form-label">{{'FILTERS.END_DATE' | translate}}</label>
            <input
              type="date" class="form-control input-field"
              [(ngModel)]="endDateFilter"
              (ngModelChange)="onFilterChange()">
            </div>
          <div class="col-md-3">
            <label class="form-label">{{'VIBRATION.NOTE' | translate}}</label>
            <input
              type="text" class="form-control input-field"
              [(ngModel)]="noteFilter"
              (input)="noteSearch$.next(noteFilter)"
              [placeholder]="'VIBRATION.NOTE' | translate">
          </div>
          </div>
        </div>
        <div class="overflow-box"  #scrollContainer>
          <div class="d-flex flex-column">
            <div class="d-flex cursor-pointer">
              <div class="checkbox-container"></div>
              <div class=" flex-grow-1 col-2" (click)="sortTable('filename')">
                <strong>{{'FORM.FILE_NAME' | translate}}</strong>
                        <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'" [ngStyle]="{
                            width: '16px',
                            height: '16px'            
                        }"/>
                </div>
                <div class=" flex-grow-1 col-2" (click)="sortTable('date')">
                  <strong>{{'FORM.DATE_AND_TIME' | translate}}</strong>
                        <img [src]="sortOrder ? './assets/icon/chevron-up.svg' : './assets/icon/chevron-down.svg'" [ngStyle]="{
                            width: '16px',
                            height: '16px'            
                        }"/>
                  </div>
                  <div class=" flex-grow-1 col-2">
                    <strong>{{'VIBRATION.NOTE' | translate}}</strong>
                  </div>
                  <div class="flex-grow-1 col-2">
                    <strong>{{'VIBRATION.MAX' | translate}}</strong>
                  </div>
                  <div class="flex-grow-1 col-2">
                    <strong>{{'RECORD.ASSIGNED' | translate}}</strong>
                  </div>
                </div>
                <div>
                  @for (record of allRecords(); track record; let j = $index) {
                    <div class="border border-2 m-3 p-3 rounded-2">
                      <div class="d-flex align-items-center cursor-pointer">
                        <div class="ps-1" style="padding-right: 1rem;" >
                          <input class="custom-checkbox" type="checkbox" [checked]="selectedRecordIds.includes(record.id)"
                            (change)="onCheckboxChange(record.id, $event)" >
                          </div>
                          <div class="flex-grow-1 col-2">
                            <strong class="colored-title">{{record?.recordMetadata.fileName}}</strong>
                          </div>
                          <div class="flex-grow-1 col-2">
                            <div>
                              <span>{{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy':'UTC'}}</span>
                            </div>
                            <div>
                              <span>
                                {{record?.recordMetadata.timestamp | date: 'HH:mm:ss':'UTC'}}
                              </span>
                            </div>
                          </div>
                          <div class="flex-grow-1 col-2">
                            <div>
                              <span>{{record?.recordMetadata.note1}}</span>
                            </div>
                            <div>
                              <span>{{record?.recordMetadata.note2}}</span>
                            </div>
                            <div>
                              <span>{{record?.recordMetadata.note3}}</span>
                            </div>
                          </div>
                          <div class="col-3">
                            <div>
                              <span>
                                V:
                                {{record?.recordMetadata.verticalPpv | number : '1.2-2'}}
                              </span>
                              <span class="ms-2">
                                L:
                                {{record?.recordMetadata.longitudinalPpv | number : '1.2-2'}}
                              </span>
                            </div>
                            <div>
                              <span>
                                T:
                                {{record?.recordMetadata.transversePpv | number : '1.2-2'}}
                              </span>
                              <span class="ms-2">
                                VS: {{record?.recordMetadata.vecSomme | number : '1.2-2'}}
                              </span>
                            </div>
                          </div>
                          <div class="flex-grow-1 d-flex align-items-center col-2">
                            <div>
                              @if (record?.controlPointId) {
                                <div><img src="./assets/icon/control-point-black.svg" /> <span
                                  class="ms-1">
                                  {{getControlPointName(record?.controlPointId)}}
                                </span>
                              </div>
                            }
                            @if (!record?.controlPointId && record?.controlPointId != 0) {
                              <div class="opacity-50 text-muted">
                                <div class="row d-flex align-items-center">
                                  <div class="col-auto">
                                    <img src="./assets/icon/question-mark.svg" />
                                  </div>
                                  <div class="col p-0">
                                    <div>{{'RECORD.MEASUREMENT_POINT' | translate}}</div>
                                    <div>{{'RECORD.UNASSIGNED' | translate}}</div>
                                  </div>
                                </div>
                              </div>
                            }
                            <div><img src="./assets/icon/device.svg" /><span class="ms-1">
                              {{record?.recordMetadata.seismographName ??
                              record?.recordMetadata.seismographSerialNumber}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-start mb-1">
            <div class="mb-1 ms-3 col-6" style="flex: 1;">
              <strong class="form-label text-center d-block" for="controlPointId">
                {{ 'RECORD.CONTROL_POINT' | translate }}
              </strong>
              <ng-select [items]="controlPoints" bindLabel="name" bindValue="controlPointId" [(ngModel)]="selectedControlPointId"
                [clearable]="true"
                >
              </ng-select>
            </div>
            <div class="ms-3 me-3 col-6" style="flex: 1;">
              <strong class="form-label text-center d-block">
                {{ 'RECORD.BLAST' | translate }}
              </strong>
              <input type="text" value="{{tirName}}"class="form-control" disabled />
            </div>
          </div>

          @if (errorMessage !== '') {
            <div class="error-message-container">
              <div class="error-message">
                <i class="fas fa-exclamation-triangle"></i>
                <span>{{ errorMessage }}</span>
                <button type="button" class="error-close-btn" (click)="closeErrorMessage()" title="Fermer">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          }

          <div class="button-group p-2">
            <button class="btn btn-secondary" (click)="closeDialog()">{{'BUTTONS.CANCEL' | translate}}</button>
            <button class="btn btn-primary" (click)="confirm()">{{'BUTTONS.CONFIRM' | translate}}</button>
          </div>
        </div>
      </div>